<h1 mat-dialog-title class="mbp-confirm-dialog__title">{{ data.title }}</h1>
<div mat-dialog-content class="mbp-confirm-dialog__content medicine-dosage-dialog">
  <mat-tab-group [(selectedIndex)]="selectedTabIndex">
    <mat-tab label="Create">
      <p class="medicine-dosage-dialog__intro">{{ data.message }}</p>
      <form [formGroup]="packageTypeForm">
        <p>
          <mat-form-field appearance="outline">
            <mat-label>Package type</mat-label>
            <input required formControlName="type" type="text" matInput>
            @if (packageTypeForm.get('type')?.invalid) {
              <mat-error>Package type is invalid</mat-error>
            }
          </mat-form-field>
        </p>
        <p>
          <mat-form-field appearance="outline">
            <mat-label>Code</mat-label>
            <input required formControlName="code" type="text" matInput>
            @if (packageTypeForm.get('code')?.invalid) {
              <mat-error>Code is invalid</mat-error>
            }
          </mat-form-field>
        </p>
      </form>
    </mat-tab>
    <mat-tab label="Manage package types">
      <core-package-type-manage-list
        (createRequested)="selectedTabIndex = 0"
        (packageTypesChange)="onPackageTypesManaged($event)">
      </core-package-type-manage-list>
    </mat-tab>
  </mat-tab-group>
</div>
@if (isManageView) {
  <div mat-dialog-actions align="end" class="mbp-confirm-dialog__actions">
    <button type="button" mat-stroked-button [mat-dialog-close]="false">Close</button>
  </div>
} @else {
  <div mat-dialog-actions align="end" class="mbp-confirm-dialog__actions">
    <button type="button" mat-stroked-button [mat-dialog-close]="false">Cancel</button>
    <button type="button" [disabled]="!packageTypeForm.valid" mat-flat-button color="primary" (click)="createPackageType()">Create</button>
  </div>
}
